export default "__VITE_ASSET__5b22c719__"